import { UserGroupIcon } from "@heroicons/react/24/outline";
import { CrudTableHeader } from "../../components/crud-table-header";
import { useTeam } from "../../context/TeamContext";
import { CompetitionTeams } from "../competitions/view/competition-teams";
import { ErrorMessage } from "../../components/error-message";
import { Loading } from "../../components/loading";

export function TeamsCRUD() {
  const { teams, isLoading, error } = useTeam();
  return (
    <div className="w-full p-8">
      <CrudTableHeader
        title="Equipos"
        count={teams?.length}
        icon={<UserGroupIcon />}
      />

      {error && (
        <div className="mb-4">
          <ErrorMessage message={error} dismissible />
        </div>
      )}

      {isLoading && <Loading />}
      {!isLoading && teams && <CompetitionTeams teams={teams} />}
    </div>
  );
}
